import React, { useEffect } from "react";
import {
    Button,
    CloseIcon,
    Dialog,
    ExclamationTriangleIcon,
    Flex,
    Text,
    TrashCanIcon,
} from "@fluentui/react-northstar";
import styled from "styled-components";

const DialogConfirmationDelete = ({
    isDeleting = false,
    disableDelete,
    trigger = null,
    handleConfirmDeleteDocument = () => null,
}) => {
    const [open, setOpen] = React.useState(false);

    const buttonTrigger = React.isValidElement(trigger) ? (
        React.cloneElement(trigger, {
            onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpen(true);
            },
            loading: isDeleting,
        })
    ) : (
        <Button
            text
            content="Supprimer"
            disabled={disableDelete}
            onClick={() => setOpen(true)}
            loading={isDeleting}
            icon={<TrashCanIcon outline />}
            styles={{
                ":not([disabled])": {
                    color: "var(--color-danger)",
                },
            }}
        />
    );

    return (
        <Dialog
            open={open}
            headerAction={{
                icon: <CloseIcon outline />,
                iconOnly: true,
                title: "Supprimer",
                onClick: () => setOpen(false),
            }}
            cancelButton={{
                content: "Annuler",
                flat: true,
            }}
            onConfirm={(e) => {
                setOpen(false);
                handleConfirmDeleteDocument(e);
            }}
            confirmButton={{
                content: "Supprimer",
                loading: isDeleting,
                styles: {
                    backgroundColor: "var(--color-danger)",
                    color: "white",
                },
                flat: true,
            }}
            header={
                <Flex gap="gap.small" vAlign="center">
                    <ExclamationTriangleIcon outline />
                    <Text
                        content={
                            "Êtes-vous sûr.e de vouloir supprimer le ou les élément(s) ?"
                        }
                    />
                </Flex>
            }
            content={
                <TextDescr content="La sélection sera définitivement supprimée et la suppression ne pourra pas être annulée." />
            }
            onCancel={() => setOpen(false)}
            trigger={buttonTrigger}
            styles={{
                width: "764px",
            }}
        />
    );
};

export default DialogConfirmationDelete;

const TextDescr = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;
